module.exports = __webpack_public_path__ + "media/img/frontend_application/edit-icon-96bde21f460aca6a4e69285d78f4df30.png";